 // app/javascript/controllers/index.js
// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
// Optional: for debugging in the console
window.application = application

import HelloController from "./hello_controller"

import DepartmentRolesController from "./department_roles_controller"
import PasswordValidationController from "./password_validation_controller"
import LoaderController from "./loader_controller"
import FlashController from "./flash_controller"

application.register("hello", HelloController)
application.register("department-roles", DepartmentRolesController)
application.register("password-validation", PasswordValidationController)
application.register("flash", FlashController)
// Hris Form
import "./hris-form"

